import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BookingService } from '@app/listing/services/booking.service';
import CheckInOutViewModel from '@app/models/check-in-out-view-model';
import CheckInRequest from '@app/models/check-in-request';
import CheckOutRequest from '@app/models/check-out-request';
import PagedResults from '@app/models/paged-results';
import { ErrorHelperService, LogService, NotificationService, UserService } from '@app/services';
import { ClickContext } from '@app/utilities/click-context';
import { LinkToUserAccountDetailComponent } from '../../../common-components/link-to-user-account-detail/link-to-user-account-detail.component';
import { LinkToNewAdminListingComponent } from '../link-to-new-admin-listing/link-to-new-admin-listing.component';
import { LinkToBookingDetailComponent } from '../../../common-components/link-to-booking-detail/link-to-booking-detail.component';
import { SpinnerComponent } from '../../../common-components/spinner/spinner.component';
import { NgIf, NgFor, NgClass } from '@angular/common';

@Component({
    selector: "check-in-out-grid",
    templateUrl: "./check-in-out-grid.component.html",
    styleUrls: ["./check-in-out-grid.component.less"],
    imports: [NgIf, SpinnerComponent, NgFor, LinkToBookingDetailComponent, LinkToNewAdminListingComponent, NgClass, LinkToUserAccountDetailComponent]
})
export class CheckInOutGridComponent implements OnInit {
  private readonly _componentName = 'CheckInCheckOutComponent';

  private _results: PagedResults;

  public rows: CheckInOutViewModel[];

  /**
   * Click context to manage single vs double click on the task row
   */
  private clickContext = new ClickContext();

  /**
   * Flag that toggles visibility of all columns vs a set of regular columns visible to users
   */
  public showAllColumns: boolean;

  public sort = 'createdOn';

  public sortDescending = true;

  /**
   * Flag that is set to true while grid data is being retrieved from the API
   */
  @Input()
  public retrieving = false;

  @Output()
  public rowClicked = new EventEmitter<CheckInOutViewModel>();

  @Output()
  public rowDoubleClicked = new EventEmitter<CheckInOutViewModel>();

  constructor(
    private log: LogService,
    private notify: NotificationService,
    private userService: UserService,
    private bookingService: BookingService,
    private errorHelper: ErrorHelperService
  ) {}

  ngOnInit() {}

  /**
   * Is verbose logging enabled
   */
  private get verboseLogging(): boolean {
    return this.log.verboseLogging;
  }

  public get isSuperAdmin(): boolean {
    return this.userService.isSuperAdmin;
  }

  public get results(): PagedResults {
    return this._results;
  }

  @Input()
  public set results(v: PagedResults) {
    this._results = v;

    if (v && v.results) {
      this.rows = v.results.map((x) => x as CheckInOutViewModel);
    } else {
      this.rows = [];
    }

    if (this.verboseLogging) {
      console.log(`${this._componentName}.results - set - rows=`, this.rows);
    }
  }

  public onSetSortClick(sortColumnName: string) {
    if (sortColumnName != this.sort) {
      this.sort = sortColumnName;

      console.log(`${this._componentName}onSetSortClick  sort=`, this.sort);

      // parcelGridRows
    } else {
      this.sortDescending = !this.sortDescending;
    }

    this.retrieveData();
  }

  public onSingleClick = this.clickContext.clickHandler((evt: MouseEvent, row: CheckInOutViewModel) => {
    this.onRowClick(evt, row);
  });

  public onDoubleClick = this.clickContext.dblClickHandler((evt: MouseEvent, row: CheckInOutViewModel) => {
    this.onRowDoubleClick(evt, row);
  });

  private retrieveData() {
    console.error('Method not implemented.');
  }

  public onRowClick(evt: MouseEvent, row: CheckInOutViewModel) {
    console.log(`${this._componentName}.onRowClick row=`, row);

    this.rowClicked.emit(row);
  }

  public onRowDoubleClick(evt: MouseEvent, row: CheckInOutViewModel) {
    console.log(`${this._componentName}.onRowDoubleClick row=`, row);

    this.rowDoubleClicked.emit(row);
  }

  public onManualCheckOut(row: CheckInOutViewModel) {
    // this.router.navigate(["/admin/booking", row.bookingId, "check-out"]);

    console.log(`${this._componentName}.onManualCheckOut()`);

    let request = {
      bookingId: row.bookingId,
      code: row.checkOutCode,
    } as CheckOutRequest;

    row.submitting = true;

    this.bookingService.checkOut(request).subscribe(
      (result) => {
        console.log(`${this._componentName} subscription result=`, result);

        this.notify.success(`Manual Checkout from: '${row.title}' successful!`);
        row.submitting = false;
        // this.successMessage = "Check In Success";
        // this.success = true;
      },
      (err) => {
        let msg = this.errorHelper.getErrorMessage(err) || 'An error occured during check in.';

        // this.errorMessage = msg;
        // this.success = false;
        row.submitting = false;

        console.error(err);
        
        this.notify.error(msg, null);
      },

      () => {
        // this.submitting = false;
      }
    );
  }

  public onManualCheckIn(row: CheckInOutViewModel) {
    console.log(`${this._componentName}.onManualCheckIn()`);

    let request = {
      bookingId: row.bookingId,
      code: row.checkInCode,
    } as CheckInRequest;

    row.submitting = true;

    this.bookingService.checkIn(request).subscribe(
      (result) => {
        console.log(`${this._componentName} subscription result=`, result);

        this.notify.success(`Manual Checkin tp: '${row.title}' successful!`);

        // this.successMessage = "Check In Success";
        // this.success = true;
        row.submitting = false;
      },
      (err) => {
        let msg = this.errorHelper.getErrorMessage(err) || 'An error occured during check in.';

        // this.errorMessage = msg;
        // this.success = false;
        row.submitting = false;

        console.error(err);
        
        this.notify.error(msg, null);
      },

      () => {
        // this.submitting = false;
      }
    );

    // this.router.navigate(["/admin/booking", row.bookingId, "check-in"]);
  }
}
